module.exports = __webpack_public_path__ + "img/one_introduction.f0edef10.svg";